import { Link } from 'react-router-dom';
import queryString from 'query-string';
// mantine
import { ActionIcon, Menu, UnstyledButton } from '@mantine/core';
// icons
import {
    AudioLines,
    MessageSquareText,
    Ellipsis,
    Link as LinkIcon
} from 'lucide-react';
// utils
import { getRecordingName } from '@newo/toolkit/bff';
import { downloadFromUrl } from '@newo/toolkit/file';
import { ISession, TRecording } from '@newo/api/gateway';
import { MENU_PORTAL, PATHS } from '@/const';

interface ActionsProps {
    session: ISession;
}

const handleClipboardCopy = async (value: string) => {
    await navigator.clipboard.writeText(value);
};

const Actions = ({ session }: ActionsProps) => {
    const params = queryString.stringify(
        {
            connectors: [`${session.integration_idn}/${session.connector_idn}`],
            user_persona_id: session.persona.id,
            session_id: session.id
        },
        { arrayFormat: 'bracket' }
    );

    const path = `${PATHS.conversations}?${params}`;
    const fullLink = `${globalThis.location.origin}${path}?${params}`;

    const handleDownload = (recording: TRecording) => {
        downloadFromUrl(recording.play_url, `session_${session.id}_recording`);
    };

    return (
        <div className="flex items-center gap-4 pr-4">
            <ActionIcon color="blue" component={Link} size="lg" to={path}>
                <MessageSquareText />
            </ActionIcon>
            <Menu
                withinPortal
                portalProps={{ target: `#${MENU_PORTAL}` }}
                shadow="md"
                width={275}
            >
                <Menu.Target>
                    <UnstyledButton>
                        <Ellipsis />
                    </UnstyledButton>
                </Menu.Target>
                <Menu.Dropdown>
                    <Menu.Item
                        leftSection={<LinkIcon />}
                        onClick={async () => handleClipboardCopy(fullLink)}
                    >
                        Copy transcription link
                    </Menu.Item>
                    {session.recordings.length > 0 && (
                        <>
                            <Menu.Divider />
                            <Menu.Label>Download Recordings</Menu.Label>
                            {session.recordings.map((recording) => {
                                return (
                                    <Menu.Item
                                        key={recording.play_url}
                                        leftSection={<AudioLines />}
                                        onClick={() => {
                                            handleDownload(recording);
                                        }}
                                    >
                                        {getRecordingName(
                                            'Recording',
                                            recording.duration,
                                            recording.file_size
                                        )}
                                    </Menu.Item>
                                );
                            })}
                        </>
                    )}
                </Menu.Dropdown>
            </Menu>
        </div>
    );
};

export default Actions;
